<template>
  <div class="tagDiv-box-tag" :name="name">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.tagDiv-box-tag {
  min-width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>